export const environment = {
  production: false,
  apiBaseUrl: 'https://staging.api.licensing.riskguardcontrols.com'
};